import {
  AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild,
  ViewChildren
} from '@angular/core';
import {
  PendingInfluencer, PendingInfluencerChannel,
  PendingInfluencerChannelStatus
} from '../../../../models/influencer/pending-influencer';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {PlaceholderVisibilityService} from '../../../services/placeholder-visibility/placeholder-visibility.service';
import {Subscription} from 'rxjs/Subscription';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NewInfluencerChanel} from '../../../../models/influencer/new-influencer';
import {Observable} from 'rxjs/Observable';
import {TranslateService} from '@ngx-translate/core';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {CommonConstant, platformIconPath} from '../../../app.constants';
import {AppSettings} from '../../../utils/app-settings';
import {ValidationHandlerService} from '../../../core/validation-handler.service';
import {ErrorTemplate} from '../../../../models/ErrorTemplate';
import {StringUtils} from '../../../utils/string.utils';
import {Subject} from 'rxjs/Subject';
import {UpdateChannelRequest} from '../../../../models/influencer-setting';
import {debounceTime, distinctUntilChanged, tap, filter} from 'rxjs/operators';
import {DismissInfluencerPopupComponent} from './dismiss-influencer-popup/dismiss-influencer-popup.component';
import {AchooFilterBoxComponent} from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { WebUtils } from '../../../utils/web.utils';

@Component({
  selector: 'influencer-review',
  templateUrl: './influencer-review.component.html',
  styleUrls: ['./influencer-review.component.scss']
})
export class InfluencerReviewComponent implements OnInit, OnDestroy {
  readonly influencerReviewLoading = 'InfluencerReviewLoading';
  @ViewChild('ErrorWhenLoadingPendingInfluencer') errorWhenLoadingPendingInfluencer: AchooPopupComponent;
  @ViewChild('PendingInfluencerSuccessNotification') pendingInfluencerSuccessNotification: AchooPopupComponent;
  @ViewChild('DeleteChannelWarning') deleteChannelWarning: AchooPopupComponent;
  @ViewChild('SubmitInfluencerConfirmation') submitInfluencerConfirmation: AchooPopupComponent;
  @ViewChild('DismissInfluencer') dismissInfluencerPopup: AchooPopupComponent;
  @ViewChild('dismissInfluencerPopupContent') dismissInfluencerPopupContent: DismissInfluencerPopupComponent;
  @ViewChild('dismissInfluencerButton') dismissInfluencerButton: ElementRef;
  @ViewChildren(AchooFilterBoxComponent) dropdownList: QueryList<AchooFilterBoxComponent>;

  @ViewChild('countrySelection') countrySelection: AchooFilterBoxComponent;
  @ViewChild('languageSelection') languageSelection: AchooFilterBoxComponent;
  @ViewChild('genderSelection') genderSelection: AchooFilterBoxComponent;
  @ViewChild('pendingInfluencerNameField') pendingInfluencerNameField: ElementRef;
  @ViewChild('AddNewChannelBtn') addNewChannelBtn: ElementRef;
  @ViewChild('backButton') backButton: ElementRef;
  @ViewChild('nextButton') nextButton: ElementRef;

  public pendingInfluencerForm: FormGroup;
  public pendingInfluencer: PendingInfluencer;
  public processingPendingInfluencer: PendingInfluencer;
  public successCompletedInfluencer: number;

  public errorMessage: string;
  public isDismissing = false;
  // reference data
  public countries;
  public languages;
  public genders;
  public platforms;
  private pendingInfluencerSubscription: Subscription;
  private validationSubscription: Subscription;
  private newChannelIndex = 0;
  private channelToDelete: PendingInfluencerChannel;
  public isLoading = false;
  public hasFieldErrors = false;
  private handleChanged: Subject<PendingInfluencerChannel> = new Subject<PendingInfluencerChannel>();
  private handleChangedSubscription: Subscription;
  private dismissInfluencerPopupRef: Subscription;
  private confirmationPopupRef;
  private fieldMapping: Map<number, any> = new Map<number, any>();
  private activeTabIndex = 1;
  constructor(private influencerService: InfluencerService,
              private modalService: ModalService,
              private formBuilder: FormBuilder,
              private translate: TranslateService,
              private referenceDataService: ReferenceDataService,
              private validator: ValidationHandlerService,
              private placeholderService: PlaceholderVisibilityService) { }

  ngOnInit() {
    this.initForm();
    this.initReferenceData();
    this.pendingInfluencerSubscription = this.influencerService.activePendingInfluencer.subscribe((data) => {
      if (data) {
        this.pendingInfluencer = data;
        this.pendingInfluencer.channels.forEach((channel) => this.updateChannelLinkInfo(channel));
        this.pendingInfluencerForm.patchValue({
          name: this.pendingInfluencer.name,
          phone: this.pendingInfluencer.phone,
          email: this.pendingInfluencer.email
        });
        this.updateFieldMapping(1);
      }
    });
    this.loadPendingInfluencer();
    this.validationSubscription = this.validator.validationErrorsSubject.subscribe((errors) => {
      const isMissingName = errors.filter(err => err.name === 'pendingInfluencer.name').length > 0;
      if (isMissingName) {
        this.pendingInfluencerForm.controls['name'].setErrors({'incorrect': true});
      } else {
        this.pendingInfluencerForm.controls['name'].setErrors(null);
      }
    });
    this.handleChangedSubscription = this.handleChanged.pipe(
        tap(channel => this.resetChannelLinkInfo(channel)),
        debounceTime(700),
        filter(channel => channel.platform_id !== undefined && channel.handle !== undefined)
      ).subscribe(channel => {
        this.precheckChannel(channel, this.pendingInfluencer.id);
      });
  }
  ngOnDestroy() {
    if (this.pendingInfluencerSubscription) {
      this.pendingInfluencerSubscription.unsubscribe();
    }
    if (this.validationSubscription) {
      this.validationSubscription.unsubscribe();
    }
    if (this.handleChangedSubscription) {
      this.handleChangedSubscription.unsubscribe();
    }
  }

  initForm() {
    this.pendingInfluencerForm = this.formBuilder.group({
      name: [ null ],
      email: [ null ],
      phone: [ null ]
    });
  }

  initReferenceData() {
    this.countries = this.referenceDataService.countries;
    this.languages = this.referenceDataService.languages;
    this.genders = CommonConstant.GENDERS;
    this.platforms = this.referenceDataService.platforms;
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.handleEnterEvent();
      event.preventDefault();
    } else if (event.keyCode === 9) {
      this.handleTabEvent();
      event.preventDefault();
    }
  }

  setActiveField(index) {
    this.activeTabIndex = index;
  }

  private handleEnterEvent() {
    const activeField = this.fieldMapping.get(this.activeTabIndex - 1);
    if (this.dismissInfluencerPopupRef) {
      if (this.dismissInfluencerPopupContent.canSubmit) {
        this.confirmDismissInfluencer({
          reason: this.dismissInfluencerPopupContent.selectedDismissReason
        });
      }
    } else if (this.confirmationPopupRef) {
      this.onAcceptToSubmitInfluencer();
    } else if (activeField && activeField.nativeElement && activeField.nativeElement instanceof HTMLButtonElement) {
      activeField.nativeElement.click();
    } else {
      this.getNextInfluencer();
    }
  }

  private handleTabEvent() {
    const activeField = this.fieldMapping.get(this.activeTabIndex);
    if (!activeField) {
      this.activeTabIndex = 1;
      return;
    }
    if (activeField instanceof AchooFilterBoxComponent) {
      if (activeField.ngSelect.isFocused) {
        activeField.ngSelect.close();
      } else {
        activeField.ngSelect.open();
      }
    } else if (activeField instanceof HTMLInputElement) {
      activeField.focus();
    } else {
      activeField.nativeElement.focus();
    }
    this.activeTabIndex = this.activeTabIndex + 1;
    if (this.activeTabIndex > this.fieldMapping.size) {
      this.activeTabIndex = 1;
    }
  }

  showLoading() {
    this.placeholderService.show(this.influencerReviewLoading);
    this.isLoading = true;
  }

  hideLoading() {
    this.placeholderService.hide(this.influencerReviewLoading);
    this.isLoading = false;
  }

  handleUpdatePendingInfluencerError() {
    this.modalService.open(this.errorWhenLoadingPendingInfluencer, null, true);
    if (this.processingPendingInfluencer) {
      this.influencerService.updatePendingInfluencerError(this.processingPendingInfluencer);
    }
  }

  handleLoadPendingInfluencerError() {
    this.errorMessage = this.translate.instant('pending_influencer.load_influencer_error');
    this.modalService.open(this.errorWhenLoadingPendingInfluencer, null, true);
    this.hideLoading();
  }

  onSubmit() {
    this.confirmationPopupRef = this.modalService.openInCenter(this.submitInfluencerConfirmation, () => {
      this.confirmationPopupRef = null;
    });
  }

  clickNext(btn: any) {
    btn.blur();
    this.getNextInfluencer();
  }

  private updateAndNext() {
    const validationErrors = this.validateInfluencerData(this.pendingInfluencer);
    if (validationErrors.length > 0) {
      this.hasFieldErrors = true;
      return;
    }

    if (this.influencerService.isLastPendingInfluencer(this.pendingInfluencer)) {
      this.updatePendingInfluencer(this.pendingInfluencer, () => {
        this.loadPendingInfluencer();
        this.processingPendingInfluencer = null;
      });
    } else {
      this.updatePendingInfluencer(this.pendingInfluencer, () => {
        this.processingPendingInfluencer = null;
      });
      this.influencerService.getNextPendingInfluencer(this.hideLoading.bind(this), this.getNextInfluencerError.bind(this));
    }
  }

  private updatePendingInfluencer(pendingInfluencer: PendingInfluencer, successCallback?) {
    this.processingPendingInfluencer = pendingInfluencer;
    this.hasFieldErrors = false;
    const influencerChannelObservers = [];
    const existingChannelIds = pendingInfluencer.channels.map(ic => ic.id);
    pendingInfluencer.channels.forEach((channel) => {
      if (channel.status === PendingInfluencerChannelStatus.NEW) {
        const newChannel = new NewInfluencerChanel(channel.platform_id);
        newChannel.handle = channel.handle;
        newChannel.influencerId = this.pendingInfluencer.id;
        influencerChannelObservers.push(this.influencerService.addInfluencerChannel(pendingInfluencer.id, newChannel).map(nc => nc.data));
      } else if (channel.handle_updated) {
        const updatedChannel = this.buildChannelUpdateDataForAPI(channel, this.pendingInfluencer.id);
        influencerChannelObservers.push(this.influencerService.updateInfluencerChannel(channel.id, updatedChannel));
      }
    });
    pendingInfluencer.is_active = 1;
    pendingInfluencer.pending_completed = true;
    pendingInfluencer.dismiss_reason = null;
    if (influencerChannelObservers.length > 0) {
      Observable.forkJoin(influencerChannelObservers).subscribe((res: any[]) => {
        const newChannelIds = res.filter(c => existingChannelIds.indexOf(c.id) < 0).map(nc => nc.id);
        const updatedChannelIds = res.filter(c => existingChannelIds.indexOf(c.id) >= 0).map(nc => nc.id);
        this.completePendingInfluencer(pendingInfluencer, newChannelIds, updatedChannelIds, successCallback);
      }, (err) => {
        this.errorMessage = this.translate.instant('pending_influencer.add_new_channel_error');
        this.handleUpdatePendingInfluencerError();
      });
    } else {
      this.completePendingInfluencer(pendingInfluencer, [], [], successCallback);
    }
  }

  private completePendingInfluencer(pendingInfluencer: PendingInfluencer, newChannelIds: number[], updatedChannelIds: number[], successCallback) {
    this.influencerService.updatePendingInfluencer(pendingInfluencer, newChannelIds, updatedChannelIds).subscribe((res) => {
      this.successCompletedInfluencer = this.processingPendingInfluencer.id;
      this.modalService.open(this.pendingInfluencerSuccessNotification, null, true);
      const completedInfluencer = res.data.pending_influencer;
      const normalizedCompletedInfluencer = Object.assign({}, completedInfluencer, {
        languages: completedInfluencer.languages && completedInfluencer.languages.length > 0 ? completedInfluencer.languages[0] : null
      });
      this.influencerService.updatePendingInfluencerList(normalizedCompletedInfluencer);
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      if (error.status !== 404) {
        this.errorMessage = this.translate.instant('pending_influencer.update_influencer_error');
        this.handleUpdatePendingInfluencerError();
      } else if (successCallback) {
        successCallback();
      }
    });
  }

  get totalPendingInfluencer() {
    return this.influencerService.getTotalPendingInfluencer();
  }

  get numberOfPendingInfluencersInCampaign() {
    return this.influencerService.getNumberOfPendingInfluencersInCampaign();
  }

  get hasErrorWithNameInput() {
    const name = this.pendingInfluencerForm.get('name');
    return name.invalid && (name.dirty || name.touched) && name.errors.required;
  }

  private loadPendingInfluencer() {
    this.showLoading();
    this.influencerService.loadPendingInfluencerList(this.hideLoading.bind(this), this.handleLoadPendingInfluencerError.bind(this));
  }

  public addNewChannel() {
    const newChannel = new PendingInfluencerChannel();
    newChannel.status = PendingInfluencerChannelStatus.NEW;
    newChannel.index = this.newChannelIndex;
    this.pendingInfluencer.channels.push(newChannel);
    this.newChannelIndex = this.newChannelIndex + 1;
    this.updateFieldMapping(6 + (this.pendingInfluencer.channels.length - 1) * 2 + 1);
  }

  public deleteChannel(channel: PendingInfluencerChannel) {
    if (channel.status === PendingInfluencerChannelStatus.NEW) {
      const deleteIdx = this.pendingInfluencer.channels.findIndex(pc => pc.index === channel.index);
      this.pendingInfluencer.channels.splice(deleteIdx, 1);
      this.updateFieldMapping(1);
    } else {
      this.channelToDelete = channel;
      this.modalService.openInCenter(this.deleteChannelWarning, () => {
        this.channelToDelete = null;
      });
    }
  }

  private updateFieldMapping(index) {
    setTimeout(() => {
      this.buildFieldMapping();
      this.activeTabIndex = index;
    }, 100);
  }

  public buildFieldMapping() {
    this.fieldMapping = new Map<number, any>();
    this.fieldMapping.set(1, this.countrySelection);
    this.fieldMapping.set(2, this.languageSelection);
    this.fieldMapping.set(3, this.genderSelection);
    this.fieldMapping.set(4, document.getElementById('ir_field_4'));
    this.fieldMapping.set(5, document.getElementById('ir_field_5'));
    this.fieldMapping.set(6, document.getElementById('ir_field_6'));
    this.pendingInfluencer.channels.forEach((channel, idx) => {
      const tabIndex = 6 + idx * 2 + 1;
      const platformField = this.dropdownList.find((c) => c.id === `ir_field_${tabIndex}`);
      if (platformField) {
        this.fieldMapping.set(tabIndex, platformField);
      }
      const handleField = document.getElementById(`ir_field_${tabIndex + 1}`);
      if (handleField) {
        this.fieldMapping.set(tabIndex + 1, handleField);
      }
    });
    const addChannelButtonTabIndex = 6 + this.pendingInfluencer.channels.length * 2 + 1;
    this.fieldMapping.set(addChannelButtonTabIndex, this.addNewChannelBtn);
    this.fieldMapping.set(addChannelButtonTabIndex + 1, this.dismissInfluencerButton);
    this.fieldMapping.set(addChannelButtonTabIndex + 2, this.backButton);
    this.fieldMapping.set(addChannelButtonTabIndex + 3, this.nextButton);
  }

  public closeDeleteChannelWarningPopup() {
    this.modalService.close();
    this.channelToDelete = null;
  }

  public onAcceptToDeleteChannel() {
    this.modalService.close();
    if (!this.channelToDelete) {
      return;
    }
    const deleteIdx = this.pendingInfluencer.channels.findIndex(pc => pc.id === this.channelToDelete.id);
    this.pendingInfluencer.channels.splice(deleteIdx, 1);
    this.updateFieldMapping(1);
    this.influencerService.deleteInfluencerChannel(this.channelToDelete.id).subscribe((res) => {
      this.channelToDelete = null;
    }, (err) => {
      this.errorMessage = this.translate.instant('pending_influencer.delete_channel_error');
      this.modalService.open(this.errorWhenLoadingPendingInfluencer, () => {
        this.errorMessage = null;
      }, true);
      // revert the change before
      this.pendingInfluencer.channels.splice(deleteIdx, 0, this.channelToDelete);
      this.updateFieldMapping(1);
    });
  }

  public onAcceptToSubmitInfluencer() {
    this.closeNotification();
    this.updateAndNext();
  }

  trackChannelFn(index, channel) {
    return index;
  }

  getPreviousInfluencer() {
    this.modalService.close();
    this.showLoading();
    this.influencerService.getPreviousPendingInfluencer(this.hideLoading.bind(this),
      this.showErrorMessage.bind(this, this.translate.instant('pending_influencer.get_previous_influencer_error')));
  }

  dismissInfluencer() {
    this.dismissInfluencerPopupRef = this.modalService.openInCenter(this.dismissInfluencerPopup, this.beforeCloseDismissPopup.bind(this), 'dismiss-influencer-popup');
    setTimeout(() => {
      this.dismissInfluencerPopupContent.dismissReason.ngSelect.open();
      this.dismissInfluencerButton.nativeElement.blur();
    }, 50);
  }

  private beforeCloseDismissPopup() {
    if (this.dismissInfluencerPopupContent) {
      this.dismissInfluencerPopupContent.selectedDismissReason = null;
      this.dismissInfluencerPopupContent.canSubmit = false;
    }
    this.dismissInfluencerPopupRef = null;
  }

  confirmDismissInfluencer(evt) {
    this.closeDismissPopup();
    this.pendingInfluencer.dismiss_reason = evt.reason;
    this.pendingInfluencer.pending_completed = true;
    this.pendingInfluencer.is_active = 2;
    this.isDismissing = true;
    this.influencerService.updatePendingInfluencer(this.pendingInfluencer, [], []).subscribe((res) => {
      this.isDismissing = false;
      this.successCompletedInfluencer = this.pendingInfluencer.id;
      this.modalService.open(this.pendingInfluencerSuccessNotification, null, true);
      this.influencerService.getNextPendingInfluencer(this.hideLoading.bind(this), this.getNextInfluencerError.bind(this));
      if (this.dismissInfluencerPopupContent) {
        this.dismissInfluencerPopupContent.selectedDismissReason = null;
        this.dismissInfluencerPopupContent.canSubmit = false;
      }
    }, (error) => {
      this.errorMessage = this.translate.instant('pending_influencer.update_influencer_error');
      this.modalService.open(this.errorWhenLoadingPendingInfluencer, null, true);
      this.isDismissing = false;
    });
  }

  closeDismissPopup() {
    this.beforeCloseDismissPopup();
    this.modalService.close();
  }

  private showErrorMessage(errorMessage) {
    this.hideLoading();
    this.errorMessage = errorMessage;
    this.modalService.open(this.errorWhenLoadingPendingInfluencer, () => {
      this.errorMessage = null;
    }, true);
  }

  getNextInfluencer() {
    const validationErrors = this.validateInfluencerData(this.pendingInfluencer);
    if (validationErrors.length > 0) {
      this.hasFieldErrors = true;
      return;
    }
    this.onSubmit();
  }

  private afterLoading() {
    this.isLoading = false;
  }

  private getNextInfluencerError() {
    this.errorMessage = this.translate.instant('pending_influencer.get_next_influencer_error');
    this.modalService.open(this.errorWhenLoadingPendingInfluencer, () => {
      this.errorMessage = null;
    }, true);
    this.isLoading = false;
  }

  private validateInfluencerData(influencer: PendingInfluencer) {
    const errors: ErrorTemplate[] = [];
    if (!influencer.name || StringUtils.trim(influencer.name) === '') {
      errors.push({name: 'pendingInfluencer.name', message: null});
    }

    if (!influencer.country) {
      errors.push({name: 'pendingInfluencer.country', message: null});
    }

    if (!influencer.languages) {
      errors.push({name: 'pendingInfluencer.languages', message: null});
    }

    if (influencer.gender === null) {
      errors.push({name: 'pendingInfluencer.gender', message: null});
    }

    influencer.channels.forEach(c => {
      if (c.handle_error || !c.handle || c.handle === '') {
        const errorKey = c.id > 0 ? `pendingInfluencerChannel${c.id}.handle` : `pendingInfluencerChannel${c.index}.handle`;
        errors.push({name: errorKey, message: null});
      }
      if (c.platform_id <= 0) {
        const errorKey = c.id > 0 ? `pendingInfluencerChannel${c.id}.platform` : `pendingInfluencerChannel${c.index}.platform`;
        errors.push({name: errorKey, message: null});
      }
    });
    return errors;
  }

  get isDisableSaveBtn() {
    const isMissingNameField = this.pendingInfluencerForm.controls['name'].invalid && this.pendingInfluencerForm.controls['name'].touched;
    return isMissingNameField || !this.pendingInfluencer.country
      || !this.pendingInfluencer.languages
      || !this.pendingInfluencer.gender === null
      || this.isLoading;
  }

  closeNotification() {
    this.modalService.close();
    this.confirmationPopupRef = null;
  }

  public getSourceId(channel: PendingInfluencerChannel) {
    return this.hasSourceIdError(channel) ? channel.source_id_error : channel.source_id;
  }

  public hasSourceIdError(channel: PendingInfluencerChannel) {
    return channel.source_id_error && channel.source_id_error != null;
  }

  changeHandle(handle, channel) {
    this.handleChanged.next(channel);
  }

  getOfficialLanguage(evt) {
    this.referenceDataService.getLanguageByCountry(evt.id).subscribe((res) => {
      this.pendingInfluencer.languages = res.id;
    });
  }

  private precheckChannel(channel: PendingInfluencerChannel, influencerId: number) {
    const channelData = this.buildChannelUpdateDataForAPI(channel, influencerId);
    this.influencerService.precheckInfluencerChannel(channel.id, channelData).subscribe((res) => {
      channel.handle_updated = true;
      channel.handle_error = null;
      this.updateChannelLinkInfo(channel);
      this.modalService.close();
    }, (error) => {
      channel.handle_error = this.translate.instant('pending_influencer.existed_handle');
      this.showErrorMessage(channel.handle_error);
    });
  }

  private buildChannelUpdateDataForAPI(channel: PendingInfluencerChannel, influencerId: number) {
    const channelData = new UpdateChannelRequest();
    channelData.id = channel.id;
    channelData.handle = channel.handle;
    channelData.type = channel.type;
    channelData.platform_id = channel.platform_id;
    channelData.blog_id = influencerId;
    if (channel.platform_id === platformIconPath.youtube.id) {
      channelData.youtubeType = CommonConstant.YOUTUBE_CHANNEL;
    }
    return channelData;
  }

  public updateChannelLink(channel) {
    this.handleChanged.next(channel);
  }

  private updateChannelLinkInfo(channel: PendingInfluencerChannel) {
    let link = null;
    let platformName = null;

    const platform = this.platforms.find(p => p.id === channel.platform_id);

    if (platform) {
      platformName = platform.name.toLowerCase();
      link = WebUtils.buildSocialChannelLink({name: platform.name, domain: platform.domain}, channel.handle);
    }

    channel.link = link;
    channel.platformName = platformName;
  }

  private resetChannelLinkInfo(channel) {
    channel.link = null;
    channel.platformName = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/admin/influencer-review/influencer-review.component.ts